import Api from "@/api/index";
import store from "@/store";
import confirmations from "./confirmations";
import alerts from "@/components/alerts/alert";
import AuthenticationService from "@/services/AuthenticationService";

const type_classes = {
  namespaced: true,
  state: {
    loading: false,
    all: [],
    datas: [],
    queryParam: {},
    modalCreate: false,
    form: {},
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
  },
  mutations: {
    SET_ALL(state, datas) {
      state.all = datas;
    },
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
    SET_MODAL_CREATE(state, data) {
      state.modalCreate = data;
    },
  },
  actions: {
    async all({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("global/param/type_class").then(({ data }) => {
        commit("SET_ALL", data);
        commit("SET_LOADING", false);
      });
    },
    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate(
        "globals/param/type_classes/page",
        payload
      ).then(({ data }) => {
        commit("SET_DATAS", data);
        commit("SET_LOADING", false);
      });
    },
    onRefresh({ state }) {
      store.dispatch("type_classes/paginate", state.queryParam);
    },
    onAction({ commit }, payload) {
      if (payload[1] === "Create") {
        commit("SET_MODAL_CREATE", true);
      } else if (payload[1] === "Detail") {
        commit("SET_DETAIL", payload[0]);
        commit("SET_MODAL_DETAIL", true);
      }
    },
    confirmation({ commit }, payload) {
      confirmations.confirmationForm(payload[0], `type_classes/${payload[1]}`);
    },
    async create({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      const params = {
        param: "type_classes",
        code: payload.description,
        description: payload.description,
      };
      return await AuthenticationService.post("backoffice/type_classes", params)
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_CREATE", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("type_classes/onRefresh");
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
  },
};

export default type_classes;
